
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/small-medium-enterprise/[category]",
      function () {
        return require("private-next-pages/small-medium-enterprise/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/small-medium-enterprise/[category]"])
      });
    }
  